<template>
  <UDashboardPanel id="no-access" :ui="{ body: 'h-full sm:p-0 p-0' }">
    <!--
    <template #header>
      <UDashboardNavbar>
        <template #leading>
          <UDashboardSidebarCollapse />
        </template>
        <template #right>
          <LanguageSwitcher />
        </template>
      </UDashboardNavbar>
    </template>
    -->

    <template #body>
      <div class="flex items-center justify-center h-full bg-(--ui-bg)">
        <div class="text-center max-w-md px-6">
          <div class="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-primary-500/10 dark:bg-primary-400/10">
            <UIcon name="i-lucide-shield-x" class="h-10 w-10 text-primary-500 dark:text-primary-400" />
          </div>
          
          <h1 class="text-2xl font-bold tracking-tight text-(--ui-text-highlighted) mb-2">
            {{ t('noAccess.title') }}
          </h1>
          
          <p class="text-(--ui-text-muted) text-sm leading-relaxed mb-8">
            {{ t('noAccess.description') }}
          </p>
          
          <UButton
            :label="t('noAccess.backHome')"
            icon="i-lucide-arrow-left"
            color="primary"
            variant="solid"
            size="lg"
            @click="router.replace('/')"
          />
        </div>
      </div>
    </template>
  </UDashboardPanel>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';

const { t } = useI18n();
const router = useRouter();
</script>
